/**
 * Auto-generated from version.json
 * Do not modify this file directly
 */
export const version = '5.10.11';
